/* with love from shopstory */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function deepClone(source) {
  return JSON.parse(JSON.stringify(source));
}

exports.deepClone = deepClone;
